
import { ISecaoLab, ISecoesComponentProps } from '@/@types/Contato/Secoes';
import { FuncionarioISecaoItem } from './FuncionarioItem';

import { FaPhoneSquareAlt } from 'react-icons/fa';
import { MdEmail } from 'react-icons/md';
import { useCallback, useEffect, useState } from 'react';
import { IUsuario } from '@/@types/Comunidade';
import { api } from '@/services/api';


/**
 * @param secaoData - dados da seção
 * @param supervisorData - dados do supervisor da seção
 * @param usuariosSecaoLab - dados dos usuários da seção
 * @returns Componente de lista de solicitações.
 */

const SecoesComponent = ({ secaoData, supervisorData, usuariosSecaoLab }: ISecoesComponentProps) => {
    const [coordenadorAssociadoData, setCoordenadorAssociadoData] = useState<IUsuario | null>(null);
    const [coordenadorAssociadoSecaoData, setCoordenadorAssociadoSecaoData] = useState<ISecaoLab | null>(null);

    const getCoordenadorAssociadoSecaoData = useCallback(async () => {
        // busca os dados da seção do coordenador associado
        const url = `/feagri/secaolabs/secoes_orgao/28.07.01.00.00`;

        await api.get<ISecaoLab[]>(url)
            .then(({ data }) => {
                setCoordenadorAssociadoSecaoData(data[0]);
            })
            .catch(err => {
                console.log(err);
            });
    }, []);

    const getCoordenadorAssociadoData = useCallback(async () => {
        // busca os dados do coordenador associado
        if (!coordenadorAssociadoSecaoData) return;
        const url = `/user/register/matricula/${coordenadorAssociadoSecaoData?.secoes_user_matricula}`;

        await api.get<IUsuario[]>(url)
            .then(({ data }) => {
                setCoordenadorAssociadoData(data[0]);
            })
            .catch(err => {
                console.log(err);
            });
    }, [coordenadorAssociadoSecaoData]);

    useEffect(() => {
        if (secaoData.secoes_orgao === '28.07.00.00.00') {
            // caso seja a seção de graduação, buscar os dados do coordenador associado
            getCoordenadorAssociadoSecaoData();
            getCoordenadorAssociadoData();
        }
    }, [secaoData, getCoordenadorAssociadoSecaoData, getCoordenadorAssociadoData])

    return (
        <div>
            {secaoData.secoes_tipo !== 'Laboratórios' && (
                //se a seção não for um laboratório, mostra o nome da seção o os dados pra contato
                <div className='flex flex-col gap-[5px] mb-[15px]'>
                    <h2 className='font-normal leading-[40px] text-[1.5rem] uppercase'>{secaoData.secoes_descricao}</h2>

                    <div className='flex items-center gap-[12px] font-normal text-[14px]'>
                        <FaPhoneSquareAlt color='#004781' size={20} />
                        {secaoData.secoes_telefones}
                    </div>

                    <div className='flex items-center gap-[12px] font-normal text-[14px]'>
                        <MdEmail color='#004781' size={20} />
                        <a target='_blank' href={`mailto:${secaoData.secoes_email}`} className='text-colorPrimary font-normal decoration-none'>{secaoData.secoes_email}</a>
                    </div>

                </div>

            )}

            <div className='flex flex-col gap-[5px] mb-[15px]'>

                {/* Mostra diferentes títulos dependendo do título da seção */}
                {secaoData.secoes_tipo === 'Laboratórios' && (
                    <h2 className='font-normal leading-[40px] text-[1.5rem] uppercase'>Funcionários Laboratório</h2>
                )}

                {secaoData.secoes_tipo === 'Seções' && (
                    <h2 className='font-normal leading-[40px] text-[1.5rem] uppercase'>Funcionarios</h2>
                )}

                {secaoData.secoes_tipo === 'Secretarias' && (
                    <h2 className='font-normal leading-[40px] text-[1.5rem] uppercase'>Secretaria</h2>
                )}

                <div>
                    {/* container dos funcionários da seção*/}
                    {usuariosSecaoLab.map(usuario => {
                        if (secaoData.secoes_docente_id != usuario._id)
                            return (
                                <FuncionarioISecaoItem
                                    nome={usuario.displayName}
                                    email={usuario.email}
                                    telefone={usuario.telefone}
                                    key={usuario._id}
                                    lattes={usuario.lattes}

                                />
                            );
                    })}
                </div>
            </div>

            <div className='flex flex-col gap-[5px] mb-[15px]'>

                {/* mostra um título diferente para o supervisor dependendo do tipo da seção */}
                {secaoData.secoes_tipo === 'Laboratórios' && (
                    <h2 className='font-normal leading-[40px] text-[1.5rem] uppercase'>Chefe de Laboratório</h2>
                )}

                {secaoData.secoes_tipo === 'Seções' && (
                    <h2 className='font-normal leading-[40px] text-[1.5rem] uppercase'>Supervisor {secaoData.secoes_descricao}</h2>
                )}

                {secaoData.secoes_tipo === 'Secretarias' && (
                    <h2 className='font-normal leading-[40px] text-[1.5rem] uppercase'>Coordenadoria</h2>
                )}

                {/* exibe os dados do supervisor da seção */}
                <FuncionarioISecaoItem
                    nome={secaoData.secoes_user_displayName}
                    email={secaoData.secoes_user_mail}
                    telefone={supervisorData?.telefone}
                    lattes={supervisorData?.lattes}
                />

            </div>

            {coordenadorAssociadoData && (
                // se houver coordenador associado
                <div>
                    <h2 className='font-normal leading-[40px] text-[1.5rem] uppercase'>Coordenador Associado</h2>

                    <FuncionarioISecaoItem
                        nome={coordenadorAssociadoSecaoData?.secoes_user_displayName}
                        email={coordenadorAssociadoSecaoData?.secoes_user_mail}
                        telefone={coordenadorAssociadoData?.telefone}
                        lattes={coordenadorAssociadoData?.lattes}
                    />
                </div>
            )}

        </div>
    );
}

export { SecoesComponent };